import React from "react";
import { Select } from "react-form";

export default ({ label, ...rest }) => {
  return (
    <div className="field">
      <label className="label">{label}</label>
      <div className="control">
        <div className="is-fullwidth select">
          <Select {...rest} />
        </div>
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/form-fields/Select.js